import * as React from "react";
const SvgLink1 = props => <svg width="inherit" height="inherit" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6.4359 5H19M19 5V17.5641M19 5L5 19" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgLink1;